export default {
  buildInfo: '/build-info',
  checkAuth: '/check-auth',
  costFormulas: '/cost-formulas',
  manufacturingCostFormulas: '/cost-formulas/mfg',
  dealEvaluation: '/evaluate/deal',
  paretoEvaluation: '/evaluate/pareto',
  dealExcelEvaluation: '/eval-excel/deal',
  deals: '/deal',
  fieldOptions: '/field-options',
  formulas: '/formula',
  formulaValidation: '/validate/formula',
  healthz: '/healthz',
  markers: '/marker-info',
  portfolioEvaluation: '/evaluate/portfolio',
  bookmark: '/bookmark',
  productRelease: '/productRelease',
};
